<template>
    <el-dialog title="更新手术间" :visible.sync="visibleSync" :close-on-click-modal="false" width="500px">
    <div v-wechat-title="title" style="height:100%;">
        <div style="margin:3px" v-if="freeRoomsList.length > 0">
            <el-button size="mini" v-for="item in freeRoomsList" :key="item.value" type="primary" plain @click="loadSlectedRoom(item)" style="margin: 10px">{{ item.label }}</el-button>
        </div>
        <div class="noRoomTitle" v-else>暂无可用手术间</div>
        <div slot="footer" class="dialog-footer" style="margin:5px">
            <el-button type="primary" @click="exchangeRoom">确 定</el-button>
        </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: `ChangeRoom`,
    props: {
        visible: { type: Boolean, default: () => false }
    },
    data() {
        return {
            title: `更换手术间`,
            token: this.$route.query.token,
            freeRoomsList: [],
            exchangeRoomItem: [],
            data: {},
            msg: `closeWindow`
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.loadFreeRooms()
    },
    computed: {
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        }
    },
    methods: {
        loadFreeRooms() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Intraoperative/Anaesthesia/GetFreeRooms`, { surgeryId: this.$route.query.surgery_id })
                req.then(data => {
                    this.freeRoomsList = data
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadSlectedRoom(item) {
            this.exchangeRoomItem = item
        },
        exchangeRoom() {
            if (this.exchangeRoomItem.value === undefined || this.exchangeRoomItem.value === ``) {
                this.$message.warning(`选择需要更换的手术间`)
                return false
            }
            return new Promise(resolve => {
                let req = this.myaxios.put(`/api/Intraoperative/Anaesthesia/ExchangeRoom`, {
                    id: this.$route.query.surgery_id,
                    dic_operating_room_id: this.exchangeRoomItem.value,
                    dic_operating_room: this.exchangeRoomItem.label
                })
                req.then(data => {
                    this.data = { id: this.$route.query.surgery_id }
                    this.data.save = true
                    this.$message.success(`更换手术间成功,请到 ${this.exchangeRoomItem.label} 继续操作!`)
                    this.$emit(`changeSurgeInfo`, this.data)
                    this.visibleSync = false
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: this.data,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {}
}
</script>
<style scoped>
.noRoomTitle {
    height: 200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: justify;
    font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/LocalAnesthesia/ChangeRoom.vue